/* eslint-disable func-names */
import { string } from 'yup';

const commonEmailValidation = (person?: string) => {
  const message = `Please input a valid ${person || ''}Email`;

  return string()
    .optional()
    .nullable()
    .email(message)
    .lowercase()
    .notOneOf(['idk@email.com', 'no@email.com'], message);
};

export const emailValidationOptional = (person?: string) => commonEmailValidation(person);

export const emailValidationRequired = (person?: string) =>
  commonEmailValidation(person).required(`${person || ''}Email is required`);
